import Image_Gui_Layout from "./assets/gui-layout.png";

const GUI = {
  images: {
    layout: Image_Gui_Layout,
  },
};

export default GUI;
